import React from 'react';
import styled from 'styled-components';

import settings from '../config/settings';

const MenuIcon = styled.div`
  background-color: ${props => props.navRevealed && '#333333'}
  border-radius: ${settings.borderRadius};
  cursor: pointer;
  height: 33px;
  padding-top: 10px;
  position: absolute;
  right: 8px;
  text-align: center;
  text-transform: uppercase;
  top: 8px;
  width: 33px;
  &:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }
  span {
    background-color: white;
    border-radius: 1px;
    display: block;
    margin: auto;
    height: 2px;
    width: 16px;
    + span {
      margin-top: 3px;
    }
  }
`;

export default (props) => (
  <MenuIcon {...props}>
    <span></span>
    <span></span>
    <span></span>
  </MenuIcon>
);



// WEBPACK FOOTER //
// ./src/components/MenuIcon.js